<template>
  <v-content>
    <v-container fluid>
      <h1 class="py-3">Graph</h1>
      <h4>Complete the below form to select a device to Graph.</h4>
      <v-alert v-if="error" :value="true" type="error">{{ error }}</v-alert>
      <SelectDeviceForm v-else v-on:validate="deviceSelected"/>
    </v-container>
  </v-content>
</template>

<script>
import moment from 'moment'
import SelectDeviceForm from '@/components/Common/SelectDeviceForm'
export default {
  name: 'GraphSelectForm',
  components: { SelectDeviceForm },
  data () {
    return {
      error: false
    }
  },
  methods: {
    deviceSelected (data) {
      /*
        Launch DeviceType specific graph action.
        All parameters: key names and graph formats obtained from device_messages API call

        LIST OF DataType Graphs 'codecs' supported:
        1) Legionella (match the first 10 characters): LegionellaV1_WT, LegionellaV2_WT
        2) Culverts: HummboxU, TankU
        3) WinterMaint: RoadConditionWT
        4) WaterUtility: PressureWT
      */
      // TODO - validate against configuration list
      var isValidated = true
      if (isValidated) {
        this.$router.push({
          name: 'DeviceTypeGraph',
          params: {
            deviceID: data.device.devicename,
            displayname: data.device.identity_data.displayname,
            devicetype: data.deviceType.typename
          },
          query: {
            datefrom: moment(data.dateFrom, 'YYYY-MM-DD').format(
              'YYYYMMDD000000'
            ),
            dateto: moment(data.dateTo, 'YYYY-MM-DD').format('YYYYMMDD235959')
          }
        })
      } else {
        this.error = `The device type (${
          data.deviceType.typename
        }) you selected is not currently supported by the Graphing API.`
      }
    }
  }
}
</script>
